import projection from '../generated/pwp5m3f1.json';
import { AcceptanceManifest } from '../types';

export const pwp5m3f1AcceptanceManifest = projection as AcceptanceManifest;
